module.exports = __webpack_public_path__ + "img/icon-credit-billing.14c7716c.png";